import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SITE_NAME } from '../config/siteBranding';
import { trainingPath } from '../utils/paths';
import AppSwitcher from './AppSwitcher';
import './TrainingTrackerShell.css';

/**
 * Lightweight chrome around the soccer training tracker so it feels part of the Training app.
 */
const TrainingTrackerShell = ({ children }) => {
  const { isAuthenticated, user, logout } = useAuth();

  return (
    <div className="training-tracker-shell">
      <header className="training-tracker-shell__topbar">
        <div className="training-tracker-shell__inner">
          <div className="training-tracker-shell__brand">
            <Link to="/" className="training-tracker-shell__site">
              {SITE_NAME}
            </Link>
            <AppSwitcher activeAppId="training" variant="compact" />
          </div>
          <nav className="training-tracker-shell__nav" aria-label="Training navigation">
            <Link to={trainingPath('/soccer')} className="training-tracker-shell__link">
              Soccer plans
            </Link>
            <Link to="/training" className="training-tracker-shell__link">
              All sports
            </Link>
            {isAuthenticated && (
              <>
                <span className="training-tracker-shell__user">
                  Hi, {user?.name?.split(' ')[0] || 'there'}
                </span>
                <button type="button" className="training-tracker-shell__btn" onClick={logout}>
                  Log out
                </button>
              </>
            )}
          </nav>
        </div>
      </header>
      <div className="training-tracker-shell__content">{children}</div>
    </div>
  );
};

export default TrainingTrackerShell;
